import React from 'react';

interface ProjectFinancialInfoProps {
  form: any;
  updateForm: (data: any) => void;
}

export function ProjectFinancialInfo({ form, updateForm }: ProjectFinancialInfoProps) {
  return (
    <section className="rounded-md bg-white p-4  border border-slate-100 space-y-4">
      <h3 className="text-sm font-normal text-slate-900 tracking-wider">Thông tin tài chính</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Tổng giá trị */}
        <div className="space-y-1.5">
          <label className="text-xs lg:text-sm font-normal text-slate-700">Tổng giá trị dự án (VND)</label>
          <input 
            type="number"
            value={form.contractAmount || ''}
            onChange={e => updateForm({ contractAmount: Number(e.target.value) })}
            placeholder="Nhập tổng giá trị"
            className="h-10 w-full rounded-md border border-slate-200 px-3 text-xs lg:text-sm font-normal text-slate-700 outline-none focus:border-emerald-500"
          />
        </div>

        {/* Ngân sách */}
        <div className="space-y-1.5">
          <label className="text-xs lg:text-sm font-normal text-slate-700">Ngân sách dự kiến (VND)</label>
          <input 
            type="number"
            value={form.budgetAmount || ''}
            onChange={e => updateForm({ budgetAmount: Number(e.target.value) })}
            placeholder="Nhập ngân sách dự kiến"
            className="h-10 w-full rounded-md border border-slate-200 px-3 text-xs lg:text-sm font-normal text-slate-700 outline-none focus:border-emerald-500"
          />
        </div>

        {/* Hình thức hợp đồng */}
        <div className="space-y-1.5">
          <label className="text-xs lg:text-sm font-normal text-slate-700">Hình thức hợp đồng</label>
          <select 
            value={form.contractType || ''}
            onChange={e => updateForm({ contractType: e.target.value })}
            className="h-10 w-full rounded-md border border-slate-200 bg-white px-3 text-xs lg:text-sm font-normal text-slate-700 outline-none focus:border-emerald-500"
          >
            <option value="">Chọn hình thức hợp đồng</option>
            <option value="lump_sum">Trọn gói</option>
            <option value="unit_price">Đơn giá</option>
          </select>
        </div>
      </div>
    </section>
  );
}
